
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Megaphone, Truck } from "lucide-react";

export const PromoBanner = () => {
  const { data: promoBanner } = useQuery({
    queryKey: ['promo-banner'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('banners')
        .select('*')
        .eq('type', 'promo')
        .eq('is_active', true)
        .single();
      
      if (error) {
        // If no promo banner found, return null
        if (error.code === 'PGRST116') return null;
        throw error;
      }
      return data;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes to prevent double requests
  });

  // Don't render if no active promo banner
  if (!promoBanner) return null;

  return (
    <div 
      className="text-white py-3 px-4 text-center w-full promo-banner"
      style={{ backgroundColor: promoBanner.background_color, color: promoBanner.text_color }}
    >
      <div className="container mx-auto flex items-center justify-center gap-2">
        <Truck className="h-5 w-5" />
        <p className="text-base font-medium">{promoBanner.title}</p>
      </div>
    </div>
  );
};
